import { ApolloLink } from "@apollo/client";
import type { FieldNode, DirectiveNode } from "graphql";
import { visit, Kind } from "graphql";

const hasMockedDirective = (node: FieldNode) =>
  Array.isArray(node.directives) &&
  node.directives.some((d: DirectiveNode) => d.name.value === "mocked");

/**
 * Strips fields and directives marked `@mocked` from the query before
 * sending it to the server.
 */
class StripMockedLink extends ApolloLink {
  constructor() {
    super((operation, forward) => {
      operation.query = visit(operation.query, {
        enter(node) {
          if (node.kind === Kind.FIELD && hasMockedDirective(node)) {
            return null;
          }
          if (node.kind === Kind.DIRECTIVE && node.name.value === "mocked") {
            return null;
          }
          return undefined;
        },
      });
      return forward(operation);
    });
  }
}

export { StripMockedLink };
